module.exports = __webpack_public_path__ + "static/img/swipe-2-1.f4cd69b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/swipe-2-1.png
// module id = fWqt
// module chunks = 10